/** Shared copy for external reviewer surfaces (Epic 160). */

export const CONTROLLED_DEMO_BANNER_TEXT =
  'Controlled demo footage. This page demonstrates the Safety Scan / Safety Case workflow, evidence packaging, corrective-action logging, follow-up workflow, and Signed Safety Scan export. It does not claim exposure reduction, accident prevention, financial ROI, or corrective-action effectiveness from looped demo footage. Production measurement is supported on live site data using matched follow-up windows and trusted observation time.';

export const RESPONSIBLE_USE_BOUNDARY_TEXT =
  'Responsible-use boundary: This report focuses on workplace conditions, exposure patterns, corrective actions, follow-up evidence, and safety records. It is not intended for worker scoring, individual ranking, productivity tracking, or disciplinary use. Human review and sign-off remain required.';

export const EXTERNAL_SAFETY_REVIEW_ROUTE_PREFIX = '/review/safety-scans';

export function externalSafetyReviewPath(reportId: string): string {
  const id = String(reportId || '').trim();
  return `${EXTERNAL_SAFETY_REVIEW_ROUTE_PREFIX}/${encodeURIComponent(id)}`;
}
